import styled from 'styled-components';

export const IE11Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
